// extracted by mini-css-extract-plugin
export var statItem = "_g5-1";
export var statsRow = "_g5-0";